import React, { useEffect, useState } from "react";
import "./KbArticle.css";
import { useLocation } from "react-router";
import { Rating, useTheme } from "@mui/material";
import BackButton from "../../../../../application/commons/back-button/back-button";
import Feedback from "../Popups/Feedback/Feedback";
import FooterMenu from "../AppsList/FooterMenu/FooterMenu";
import FeedbackGreet from "../Popups/FeedbackGreet/FeedbackGreet";

const KbArticle: React.FC = () => {
  const location = useLocation();
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [feedbackGreet, setFeedbackGreet] = useState(false);
  const theme = useTheme();

  const { passedKbArticle } = location.state || {};
  console.log("passed kb Article", passedKbArticle);

  const handleFeedback = () => {
    setFeedbackModal(!feedbackModal);
  }

  const handleGoodFeedback = () => {
    console.log("Like");
    setFeedbackGreet(!feedbackGreet);
  }

  return (
    <>
      <div className="kbArticleWrapper">
        <div className="row1">
          <div id="back" className="back">
            <BackButton></BackButton>
          </div>
          <h5 style={{ fontWeight: "600", marginBottom: "0px" }}>
            {passedKbArticle?.short_description}
          </h5>
          {passedKbArticle.Link && (
            <a
              style={{
                padding: "0px 10px",
                background: "#88888826",
                borderRadius: "50px",
              }}
              href={passedKbArticle.Link}
              target="_blank"
            >
              <i className="bi bi-link-45deg"></i>
            </a>
          )}
        </div>
        {/* <div style={{padding: '0px 16px'}}>
            <Rating value={Number(passedKbArticle?.rating)} readOnly />
            </div> */}
        <div
          style={{ margin: "0px 16px", marginTop: "8px", backgroundColor: 'var(--cards-bg-color)' }}
          className="contentBox"
        >
          <h5>Summary</h5>
          <div style={{ whiteSpace: "pre-line", height: '-webkit-fill-available', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', color: 'var(--header-text-color)' }}>
            <div className={theme.palette.mode === 'dark' ? 'kb-article-wrapper' : ''} dangerouslySetInnerHTML={{ __html: passedKbArticle.text }}>
              {/* {passedKbArticle.text} */}
            </div>
            {/* {Object.entries(passedKbArticle.Steps).map(([key, value]) => (
              <li style={{ marginBottom: "4px" }} key={key}>
                {typeof value === "string" ? value : ""}
              </li>
            ))} */}

            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginTop: '20px', padding: '16px', borderTop: '1px solid lightgrey', gap: '6px' }}>
              <p style={{ margin: 0, fontSize: '12px', fontWeight: 300 }}>Provide your feedback</p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                <div className="feedback-icn">
                  <i className="bi bi-hand-thumbs-up" onClick={() => handleGoodFeedback()}></i>

                </div>
                <div className="feedback-icn">
                  <i className="bi bi-hand-thumbs-down" onClick={() => handleFeedback()}></i>

                </div>

              </div>
            </div>

            {feedbackModal && (
              <Feedback
                feedbackModal={feedbackModal}
                setFeedbackModal={setFeedbackModal}
                feedbackGreet = {feedbackGreet}
                setFeedbackGreet = {setFeedbackGreet}
              />
            )}

            {feedbackGreet && (
              <FeedbackGreet
                feedbackGreet = {feedbackGreet}
                setFeedbackGreet = {setFeedbackGreet}
              />
            )}

          </div>
        </div>

        <FooterMenu></FooterMenu>

      </div>
    </>
  );
};

export default KbArticle;
